import { render } from "./Accreditations.vue?vue&type=template&id=2e31295f&scoped=true"
import script from "./Accreditations.vue?vue&type=script&lang=js"
export * from "./Accreditations.vue?vue&type=script&lang=js"

import "./Accreditations.vue?vue&type=style&index=0&id=2e31295f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e31295f"]])

export default __exports__